"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartOverlay = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.ChartOverlay = react_1.forwardRef(function (_a, ref) {
    var onMouseMove = _a.onMouseMove, onMouseLeave = _a.onMouseLeave, onMouseEnter = _a.onMouseEnter, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight;
    return (react_1.default.createElement("rect", { ref: ref, width: chartWidth, height: chartHeight, pointerEvents: "all", fill: "none", onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, "data-test-component-name": "chart-overlay" }));
});
